import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import React from 'react';
import { readConfObject } from '@jbrowse/core/configuration';
import { observer } from 'mobx-react';
import FeatureLabel from './FeatureLabel';
function FeatureGlyph(props) {
  var _a, _b, _c, _d;
  var feature = props.feature,
    rootLayout = props.rootLayout,
    config = props.config,
    name = props.name,
    description = props.description,
    shouldShowName = props.shouldShowName,
    shouldShowDescription = props.shouldShowDescription;
  var featureLayout = rootLayout.getSubRecord(String(feature.id()));
  if (!featureLayout) {
    return null;
  }
  var _ref = featureLayout.data || {},
    GlyphComponent = _ref.GlyphComponent;
  return React.createElement("g", null, React.createElement(GlyphComponent, _objectSpread({
    featureLayout: featureLayout
  }, props)), shouldShowName ? React.createElement(FeatureLabel, _objectSpread({
    text: name,
    x: ((_a = rootLayout.getSubRecord('nameLabel')) === null || _a === void 0 ? void 0 : _a.absolute.left) || 0,
    y: ((_b = rootLayout.getSubRecord('nameLabel')) === null || _b === void 0 ? void 0 : _b.absolute.top) || 0,
    color: readConfObject(config, ['labels', 'nameColor'], {
      feature: feature
    }),
    featureWidth: featureLayout.width
  }, props)) : null, shouldShowDescription ? React.createElement(FeatureLabel, _objectSpread({
    text: description,
    x: ((_c = rootLayout.getSubRecord('descriptionLabel')) === null || _c === void 0 ? void 0 : _c.absolute.left) || 0,
    y: ((_d = rootLayout.getSubRecord('descriptionLabel')) === null || _d === void 0 ? void 0 : _d.absolute.top) || 0,
    color: readConfObject(config, ['labels', 'descriptionColor'], {
      feature: feature
    }),
    featureWidth: featureLayout.width
  }, props)) : null);
}
export default observer(FeatureGlyph);